import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
type ModalType = 'privacy' | 'terms' | null;
export function Footer() {
  const [activeModal, setActiveModal] = useState<ModalType>(null);
  return <>
      <footer className="py-6 md:py-8 border-t border-white/5 bg-deep-black" data-id="element-66">
        <div className="max-w-4xl mx-auto px-6 flex flex-col sm:flex-row items-center justify-between gap-3" data-id="element-67">
          <p className="text-white/30 text-xs font-light" data-id="element-68">
            © {new Date().getFullYear()} L'Algorithme de l'Amour. Tous droits
            réservés.
          </p>
          <div className="flex items-center gap-6" data-id="element-69">
            <button onClick={() => setActiveModal('privacy')} className="text-white/40 hover:text-champagne-gold text-xs font-light tracking-wide transition-colors cursor-pointer" data-id="element-70">
              Politique de Confidentialité
            </button>
            <span className="text-white/10" data-id="element-71">|</span>
            <button onClick={() => setActiveModal('terms')} className="text-white/40 hover:text-champagne-gold text-xs font-light tracking-wide transition-colors cursor-pointer" data-id="element-72">
              Conditions Générales
            </button>
          </div>
        </div>
      </footer>

      {/* Modal Overlay */}
      <AnimatePresence data-id="element-73">
        {activeModal && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.2
      }} className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-black/80 backdrop-blur-sm" onClick={() => setActiveModal(null)} data-id="element-74">
            <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} transition={{
          duration: 0.3,
          ease: [0.21, 0.47, 0.32, 0.98]
        }} onClick={e => e.stopPropagation()} className="relative w-full max-w-2xl max-h-[80vh] bg-deep-black border border-burgundy/40 rounded-2xl overflow-hidden shadow-2xl" data-id="element-75">
              {/* Header */}
              <div className="sticky top-0 z-10 flex items-center justify-between p-5 border-b border-white/10 bg-deep-black/95 backdrop-blur-sm" data-id="element-76">
                <h3 className="font-playfair text-xl text-cream" data-id="element-77">
                  {activeModal === 'privacy' ? 'Politique de Confidentialité' : 'Conditions Générales'}
                </h3>
                <button onClick={() => setActiveModal(null)} className="p-2 rounded-full hover:bg-white/10 transition-colors cursor-pointer" data-id="element-78">
                  <X size={18} className="text-white/60" data-id="element-79" />
                </button>
              </div>

              {/* Content */}
              <div className="p-6 overflow-y-auto max-h-[calc(80vh-70px)] text-muted-cream font-light text-sm leading-relaxed space-y-5" data-id="element-80">
                {activeModal === 'privacy' ? <PrivacyContent data-id="element-81" /> : <TermsContent data-id="element-82" />}
              </div>
            </motion.div>
          </motion.div>}
      </AnimatePresence>
    </>;
}
function PrivacyContent() {
  return <>
      <p className="text-champagne-gold font-playfair text-lg" data-id="element-83">
        Dernière mise à jour : Avril 2026
      </p>

      <div className="space-y-4" data-id="element-84">
        <h4 className="text-cream font-medium text-base" data-id="element-85">
          1. Collecte des Données
        </h4>
        <p data-id="element-86">
          Nous collectons uniquement les informations nécessaires au traitement
          de ta commande : adresse e-mail et informations de paiement. Aucune
          donnée personnelle n'est partagée avec des tiers à des fins
          commerciales.
        </p>
      </div>

      <div className="space-y-4" data-id="element-87">
        <h4 className="text-cream font-medium text-base" data-id="element-88">
          2. Utilisation des Données
        </h4>
        <p data-id="element-89">Tes données sont utilisées exclusivement pour :</p>
        <ul className="list-disc list-inside space-y-1 ml-2" data-id="element-90">
          <li data-id="element-91">Livrer ton produit numérique</li>
          <li data-id="element-92">T'envoyer ta confirmation d'achat</li>
          <li data-id="element-93">Assurer le service après-vente et la garantie</li>
        </ul>
      </div>

      <div className="space-y-4" data-id="element-94">
        <h4 className="text-cream font-medium text-base" data-id="element-95">
          3. Protection des Données
        </h4>
        <p data-id="element-96">
          Toutes les transactions sont sécurisées par un cryptage SSL. Tes
          informations de paiement ne sont jamais stockées sur nos serveurs.
        </p>
      </div>

      <div className="space-y-4" data-id="element-97">
        <h4 className="text-cream font-medium text-base" data-id="element-98">4. Cookies</h4>
        <p data-id="element-99">
          Notre site utilise des cookies essentiels au fonctionnement du service
          et des cookies analytiques pour améliorer ton expérience. Tu peux les
          désactiver dans les paramètres de ton navigateur.
        </p>
      </div>

      <div className="space-y-4" data-id="element-100">
        <h4 className="text-cream font-medium text-base" data-id="element-101">5. Tes Droits</h4>
        <p data-id="element-102">
          Conformément au RGPD, tu disposes d'un droit d'accès, de rectification
          et de suppression de tes données personnelles. Tu peux exercer ces
          droits à tout moment.
        </p>
      </div>

      <div className="space-y-4" data-id="element-103">
        <h4 className="text-cream font-medium text-base" data-id="element-104">
          6. Confidentialité de l'Achat
        </h4>
        <p data-id="element-105">
          L'achat apparaît de manière discrète et confidentielle sur ton relevé
          bancaire. Aucune mention explicite du produit n'y figure.
        </p>
      </div>
    </>;
}
function TermsContent() {
  return <>
      <p className="text-champagne-gold font-playfair text-lg" data-id="element-106">
        Dernière mise à jour : Avril 2026
      </p>

      <div className="space-y-4" data-id="element-107">
        <h4 className="text-cream font-medium text-base" data-id="element-108">1. Objet</h4>
        <p data-id="element-109">
          Les présentes conditions générales régissent la vente du produit
          numérique « L'Algorithme de l'Amour : L'Effet Obsession » et de ses
          bonus associés.
        </p>
      </div>

      <div className="space-y-4" data-id="element-110">
        <h4 className="text-cream font-medium text-base" data-id="element-111">2. Produit</h4>
        <p data-id="element-112">
          Le produit est un guide numérique au format PDF, livré par
          téléchargement immédiat après validation du paiement. Il comprend
          l'ebook principal et les bonus mentionnés sur la page de vente.
        </p>
      </div>

      <div className="space-y-4" data-id="element-113">
        <h4 className="text-cream font-medium text-base" data-id="element-114">
          3. Prix et Paiement
        </h4>
        <p data-id="element-115">
          Le prix affiché est en dollars américains (USD), toutes taxes
          comprises. Le paiement est sécurisé et traité par notre prestataire de
          paiement certifié.
        </p>
      </div>

      <div className="space-y-4" data-id="element-116">
        <h4 className="text-cream font-medium text-base" data-id="element-117">4. Livraison</h4>
        <p data-id="element-118">
          Le produit est livré instantanément par voie électronique. Un lien de
          téléchargement t'est envoyé immédiatement après le paiement. Le
          produit est lisible sur smartphone, tablette et ordinateur.
        </p>
      </div>

      <div className="space-y-4" data-id="element-119">
        <h4 className="text-cream font-medium text-base" data-id="element-120">
          5. Garantie Satisfaite ou Remboursée
        </h4>
        <p data-id="element-121">
          Tu bénéficies d'une garantie de remboursement intégral de 30 jours à
          compter de la date d'achat. Aucune justification n'est requise. Le
          remboursement est traité sous 5 jours ouvrés.
        </p>
      </div>

      <div className="space-y-4" data-id="element-122">
        <h4 className="text-cream font-medium text-base" data-id="element-123">
          6. Propriété Intellectuelle
        </h4>
        <p data-id="element-124">
          Le contenu du produit est protégé par le droit d'auteur. Toute
          reproduction, distribution ou revente, partielle ou totale, est
          strictement interdite sans autorisation écrite préalable.
        </p>
      </div>

      <div className="space-y-4" data-id="element-125">
        <h4 className="text-cream font-medium text-base" data-id="element-126">7. Responsabilité</h4>
        <p data-id="element-127">
          Les résultats obtenus dépendent de l'application individuelle des
          conseils fournis. Nous ne garantissons aucun résultat spécifique. Le
          produit est fourni à titre informatif et éducatif.
        </p>
      </div>
    </>;
}